const FilterFooterIcon = ({ active }: any) =>
{
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4258 6.875C15.8424 6.875 16.1758 6.54167 16.1758 6.125V2.25C16.1758 1.83333 15.8424 1.5 15.4258 1.5C15.0091 1.5 14.6758 1.83333 14.6758 2.25V6.125C14.6758 6.53333 15.0174 6.875 15.4258 6.875Z"
        fill={active ? "var(--color-icon-btn-action-footer-active)" : "var(--color-icon-btn-action-footer)"}
      />
      <path
        d="M10 13.125C9.58333 13.125 9.25 13.4583 9.25 13.875V17.75C9.25 18.1667 9.58333 18.5 10 18.5C10.4167 18.5 10.75 18.1667 10.75 17.75V13.875C10.75 13.4667 10.4167 13.125 10 13.125Z"
        fill={active ? "var(--color-icon-btn-action-footer-active)" : "var(--color-icon-btn-action-footer)"}
      />
      <path
        d="M4.57422 6.875C4.99089 6.875 5.32422 6.54167 5.32422 6.125V2.25C5.32422 1.83333 4.99089 1.5 4.57422 1.5C4.15755 1.5 3.82422 1.83333 3.82422 2.25V6.125C3.82422 6.53333 4.15755 6.875 4.57422 6.875Z"
        fill={active ? "var(--color-icon-btn-action-footer-active)" : "var(--color-icon-btn-action-footer)"}
      />
      <path
        d="M6.12539 8.4751H3.02539C2.60872 8.4751 2.27539 8.80843 2.27539 9.2251C2.27539 9.64176 2.60872 9.9751 3.02539 9.9751H3.82539V17.7501C3.82539 18.1668 4.15872 18.5001 4.57539 18.5001C4.99206 18.5001 5.32539 18.1668 5.32539 17.7501V9.9751H6.12539C6.54206 9.9751 6.87539 9.64176 6.87539 9.2251C6.87539 8.80843 6.53372 8.4751 6.12539 8.4751Z"
        fill={active ? "var(--color-icon-btn-action-footer-active)" : "var(--color-icon-btn-action-footer)"}
      />
      <path
        d="M16.975 8.4751H13.875C13.4583 8.4751 13.125 8.80843 13.125 9.2251C13.125 9.64176 13.4583 9.9751 13.875 9.9751H14.675V17.7501C14.675 18.1668 15.0083 18.5001 15.425 18.5001C15.8417 18.5001 16.175 18.1668 16.175 17.7501V9.9751H16.975C17.3917 9.9751 17.725 9.64176 17.725 9.2251C17.725 8.80843 17.3917 8.4751 16.975 8.4751Z"
        fill={active ? "var(--color-icon-btn-action-footer-active)" : "var(--color-icon-btn-action-footer)"}
      />
      <path
        d="M11.5492 10.025H10.7492V2.25C10.7492 1.83333 10.4159 1.5 9.99922 1.5C9.58255 1.5 9.24922 1.83333 9.24922 2.25V10.025H8.44922C8.03255 10.025 7.69922 10.3583 7.69922 10.775C7.69922 11.1917 8.03255 11.525 8.44922 11.525H11.5492C11.9659 11.525 12.2992 11.1917 12.2992 10.775C12.2992 10.3583 11.9659 10.025 11.5492 10.025Z"
        fill={active ? "var(--color-icon-btn-action-footer-active)" : "var(--color-icon-btn-action-footer)"}
      />
    </svg>
  );
};

export default FilterFooterIcon;
